import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Switch } from "@mui/material";
import PropTypes from "prop-types";

function InputToggle(props) {
  return (
    <List>
      <ListItem
        disablePadding
        sx={(theme) => ({
          border: "1px solid rgba(0,0,0,.23)",
          borderRadius: 1,
          transition: "all .2s ease-in-out",
          minHeight: 38,
          height: "auto",
          "&:hover": {
            background: "inherit",
            borderColor: "rgba(0,0,0,0.87)",
          },
          ...theme.applyStyles("dark", {
            borderColor: "rgba(255,255,255,.23)",
            "&:hover": {
              borderColor: "#fff",
            },
          }),
        })}
      >
        <ListItemButton
          onClick={() => props.onChange(props.id, props.value === props.states[1] ? props.states[0] : props.states[1])}
          disabled={props.disabled}
          sx={{ minHeight: 38 }}
        >
          <ListItemIcon sx={{ minWidth: 40, p: 0 }}>
            <Switch
              id={props.id}
              disabled={props.disabled}
              checked={props.value === props.states[1]}
              value={props.id}
              tabIndex={-1}
            />
          </ListItemIcon>
          <ListItemText
            primary={props.primary}
            secondary={props.secondary}
            sx={{
              ".MuiTypography-root": {
                whiteSpace: "normal",
                overflow: "visible",
              },
            }}
          />
        </ListItemButton>
      </ListItem>
    </List>
  );
}

InputToggle.propTypes = {
  id: PropTypes.string,
  primary: PropTypes.string,
  secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  states: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool])),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default InputToggle;
